import { Check, Copy } from "lucide-react";
import { useState } from "react";

interface CopyButtonProps {
  value: string;
  /** Accessible label, e.g. "Copy email". */
  label: string;
}

/** Small icon button that copies `value` to the clipboard, with brief feedback. */
export function CopyButton({ value, label }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Clipboard access can be denied (e.g. insecure context); ignore.
    }
  };

  return (
    <button
      type="button"
      className="copy-button"
      onClick={handleCopy}
      title={copied ? "Copied!" : label}
      aria-label={label}
    >
      {copied ? <Check size={13} /> : <Copy size={13} />}
    </button>
  );
}
